import styled, { createGlobalStyle } from "styled-components";
import chroma from "chroma-js";

export const GlobalTooltipStyles = createGlobalStyle`
	.basic-tooltip:not(.dark) {
		background-color: ${(props) =>
      props.tooltipColor !== null ? props.tooltipColor : "#00B5B8"} !important;
		opacity: 1;
	}
	.basic-tooltip:not(.dark)::after {
		border-color: ${(props) =>
      props.tooltipColor !== null ? props.tooltipColor : "#00B5B8"} !important;
		background-color: ${(props) =>
      props.tooltipColor !== null ? props.tooltipColor : "#00B5B8"} !important;
	}
`;

export const ColorDiv = styled.div`
  .text-black {
    color: ${(props) => props.textBlack};
  }
  .text-primary-black {
    color: ${(props) => props.textPrimaryBlack};
  }
  .text-primary-black-disabled {
    color: ${(props) => props.textPrimaryBlackDisabled};
  }
  .text-secondary-black {
    color: ${(props) => props.textSecondaryBlack};
  }
  .text-table-black {
    color: ${(props) => props.textTableBlack};
  }
  .text-interaction {
    color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .text-error {
    color: ${(props) =>
      props.errorColor !== null ? props.errorColor : "#FF4C51"};
  }
  .border-error {
    border-color: ${(props) =>
      props.errorColor !== null ? props.errorColor : "#FF4C51"};
  }
  .bg-interaction {
    background-color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .bg-interaction-clear {
    background-color: ${(props) =>
      props.interactionColor !== null
        ? `${props.interactionColor}29`
        : "#00B5B829"};
  }
  .navbar-dark,
  .navbar-semi-light {
    background-color: ${(props) =>
      props.headerColor !== null ? props.headerColor : "#404E67"};
  }
  .navbar-semi-dark .navbar-header {
    background-color: ${(props) =>
      props.headerColor !== null ? props.headerColor : "#404E67"};
  }
  .navbar-dark .navbar-nav .nav-link,
  .navbar-semi-light .navbar-nav .nav-link {
    color: ${(props) =>
      props.headerColor !== null &&
      chroma(props.headerColor || "#00B5B8").luminance() > 0.5
        ? "black"
        : "#FFF"};
  }
  .bg-primary {
    background-color: ${(props) =>
      props.bannerColor !== null ? props.bannerColor : "#00B5B8"} !important;
  }
  .fdes .col .badge-white-title {
    color: ${(props) =>
      props.bannerColor !== null ? props.bannerColor : "#00B5B8"} !important;
  }
  .__react_component_tooltip.show {
    z-index: 9999;
  }

  .main-menu .navigation li.active {
    border-left: 4px solid
      ${(props) =>
        props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .main-menu .navigation > li.active > a {
    color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .dropdown-item.active,
  .dropdown-item:active {
    color: white;
    background-color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  a {
    color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .btn-outline-primary {
    color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
    border-color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .btn-outline-primary:hover {
    background-color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    background-color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .btn-outline-primary:not(:disabled):not(.disabled).active,
  .btn-outline-primary:not(:disabled):not(.disabled):active,
  .show > .btn-outline-primary.dropdown-toggle {
    background-color: ${(props) =>
      props.interactionColor !== null
        ? chroma(props.interactionColor || "#00B5B8").darken(1)
        : "#00B5B8"};
    border-color: ${(props) =>
      props.interactionColor !== null
        ? chroma(props.interactionColor || "#00B5B8").darken(1)
        : "#00B5B8"};
  }
  .btn-primary {
    background-color: ${(props) =>
      props.interactionColor !== null
        ? props.interactionColor
        : "#00B5B8"}!important;
    border-color: ${(props) =>
      props.interactionColor !== null
        ? props.interactionColor
        : "#00B5B8"}!important;
    color: ${(props) =>
      props.interactionColor !== null &&
      chroma(props.interactionColor || "#00B5B8").luminance() > 0.5
        ? "black"
        : "#FFF"}!important;
  }
  .btn-primary.outlined {
    background-color: transparent !important;
    border-color: ${(props) =>
      props.interactionColor !== null
        ? props.interactionColor
        : "#00B5B8"}!important;
    color: ${(props) =>
      props.interactionColor !== null
        ? props.interactionColor
        : "#00B5B8"}!important;
  }
  .btn-primary:hover:not(:disabled):not(.disabled) {
    background-color: ${(props) =>
      props.interactionColor !== null
        ? chroma(props.interactionColor || "#00B5B8").luminance() > 0.5
          ? chroma(props.interactionColor || "#00B5B8").darken(0.5)
          : chroma(props.interactionColor || "#00B5B8").brighten(0.5)
        : "#00B5B8"}!important;
    border-color: ${(props) =>
      props.interactionColor !== null
        ? chroma(props.interactionColor || "#00B5B8").luminance() > 0.5
          ? chroma(props.interactionColor || "#00B5B8").darken(0.5)
          : chroma(props.interactionColor || "#00B5B8").brighten(0.5)
        : "#00B5B8"}!important;
    color: ${(props) =>
      props.interactionColor !== null &&
      chroma(props.interactionColor || "#00B5B8").luminance() > 0.5
        ? "black"
        : "#FFF"}!important;
  }
  .nav.nav-tabs.nav-underline .nav-item a.nav-link {
    color: ${(props) => props.textPrimaryBlack};
  }
  .nav.nav-tabs.nav-underline .nav-item a.nav-link.active {
    color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#2DCEE3"};
  }
  .nav.nav-tabs.nav-underline .nav-item a.nav-link:before {
    background: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .form-control:focus {
    border-color: ${(props) =>
      props.interactionColor !== null
        ? props.interactionColor
        : "#00B5B8"}!important;
  }
  .dropdown-item {
    color: #2a2e30;
  }
  .slider-container {
    .noUi-horizontal .noUi-handle {
      border: 5px solid
        ${(props) =>
          props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
    }
  }
  .page-item .page-link {
    color: ${(props) => props.textPrimaryBlack}!important;
  }
  .pagination .page-item .page-link:hover {
    color: ${(props) =>
      props.interactionColor !== null
        ? props.interactionColor
        : "#00B5B8"}!important;
  }
  .pagination .page-item.active .page-link {
    color: ${(props) =>
      props.interactionColor !== null &&
      chroma(props.interactionColor || "#00B5B8").luminance() > 0.5
        ? props.textPrimaryBlack
        : "#FFF"}!important;
    background-color: ${(props) =>
      props.interactionColor !== null
        ? props.interactionColor
        : "#00B5B8"}!important;
  }
  .pagination .page-item.disabled .page-link {
    color: ${(props) => props.textPrimaryBlackDisabled}!important;
  }
  .calculs table thead tr th .sort-container span {
    color: ${(props) => props.textPrimaryBlackDisabled}!important;
  }
  .calculs table thead tr th .sort-container span.active {
    color: ${(props) => props.textPrimaryBlack}!important;
  }
  .tableFixHead thead th {
    color: ${(props) => props.textSecondaryBlack}!important;
  }
  table {
    color: ${(props) => props.textTableBlack}!important;
  }
  .checkbox-primary.checkbox-already-in-folder:checked {
    background-color: ${(props) =>
      props.interactionColor !== null
        ? `${props.interactionColor}`
        : "#00B5B8"};
    border-color: ${(props) =>
      props.interactionColor !== null
        ? `${props.interactionColor}`
        : "#00B5B8"};
    opacity: 0.5;
  }
  .checkbox-primary:checked {
    background-color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
    border-color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
  .folder-table-icon {
    color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
    background-color: ${(props) =>
      props.interactionColor !== null
        ? `${props.interactionColor}29`
        : "#00B5B829"};
  }
  .dropdown .dropdown-menu .dropdown-item:hover {
    color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
    background-color: ${(props) =>
      props.interactionColor !== null
        ? `${props.interactionColor}29`
        : "#00B5B829"};
  }
  .folders-details {
    color: ${(props) =>
      props.interactionColor !== null ? props.interactionColor : "#00B5B8"};
  }
`;
